/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { AccessType } from "@quintype/components";
import { TextField } from "../../atoms/textfield";
import {
  updateFirebaseUser,
  checkForMemberInFirebase,
  getPodcastToken,
  getDiscordIdByEmail,
  linkDiscordAccount,
  getShopifyOrders
} from "../../helper/api";
import { ACCOUNT_DETAILS_URL } from "../../../constants";
import { LoginButton } from "../../molecules/login-button";
import Loader from "../../atoms/loader";
import {
  IS_SUBSCRIPTION_CANCEL,
  SELECTED_PLAN,
  PAYMENT_CHECKOUT_PAGE
} from "../../helper/actions";
import IntegrationData from "../../../../../config/integrations.js";
import "./account-details.m.css";
import { MdContentCopy } from "react-icons/md";
import { useUserSubscription, useCopyToClipboard } from "../../helper/hooks";
import { isEmpty } from "lodash";
import { Button } from "../../atoms/button";
import { CancelPrompt } from "./cancelprompt";
// import { AiFillAndroid } from "react-icons/ai";
const shows = require("./shows.json");

const GetCards = ({
  subscriptions = [],
  config,
  navigateTo,
  cancelSubscription,
  subscriptionManage,
  cancelPrompt,
  member,
  isSubscriptionCanceled,
  selectedPlan,
  groupSubscription,
  campaignSubscriptions,
  hostUrl,
  user,
  showCTA = true
}) => {
  const [sucMessage, setsucMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [cancelSubscriptionState, setCancelSubcription] = useState({});
  const [cancelProm, setCancelProm] = cancelPrompt;

  const CancelSubscriptionPlan = () => {
    setCancelProm(true);
  };

  const CancelSub = subscription => {
    setCancelProm(false);
    setLoading(true);
    setCancelSubcription(subscription);
    cancelSubscription(subscription.id)
      .then(() => {
        setLoading(false);
        subscriptionManage({ status: true });
        setsucMessage("Your subscription has been cancelled");
        setTimeout(() => {
          setsucMessage(" ");
        }, 3000);
      })
      .catch(error => {
        setLoading(false);
        subscriptionManage({ status: false });
        setErrorMessage(error.message);
        setTimeout(() => {
          setErrorMessage(" ");
        }, 3000);
      });
  };
  const paymentCheckout = subscription => {
    if (subscription.subscription_type === "campaign") {
      const renewSubscriptions =
        campaignSubscriptions.map(plans =>
          plans.subscription_plans.filter(
            plan => plan.id === subscription.subscription_plan_id
          )
        ) || [];
      const renewSubscription =
        renewSubscriptions.filter(sub => sub.length > 0 && sub[0]) || [];
      selectedPlan(renewSubscription[0][0], ACCOUNT_DETAILS_URL);
      navigateTo(`/payment-checkout`);
    } else {
      const renewSubscriptions =
        groupSubscription.map(plans =>
          plans.subscription_plans.filter(
            plan => plan.id === subscription.subscription_plan_id
          )
        ) || [];
      const renewSubscription =
        renewSubscriptions.filter(sub => sub.length > 0 && sub[0]) || [];
      selectedPlan(renewSubscription[0][0], ACCOUNT_DETAILS_URL);

      navigateTo(`/payment-checkout`);
    }
  };

  if (subscriptions.length === 0) {
    return (
      <div styleName="sub-wrraper">
        <h4 styleName="plan-name no-plan">You do not have any plan</h4>
      </div>
    );
  }
  return subscriptions.map(subscription => {
    const defaultImg = get(
      config,
      ["publisher", "publisher", "defaultSubImg"],
      ""
    );
    const isCancelled = isSubscriptionCanceled || subscription.cancelled;
    const description =
      (subscription.group_description &&
        subscription.group_description.split("\n")) ||
      [];
    let imgUrl = description.length > 1 ? description[0] : defaultImg;
    // let summary =
    //   description && description.length === 1 ? description[0] : description[1];

    if (subscription.subscription_type === "campaign") {
      try {
        const res = JSON.parse(subscription.group_description);
        imgUrl = res.imageUrl;
        // summary = res.summary;
      } catch (e) {
        console.log("campign description is not a valid JSON ", subscription);
        console.error(e);
      }
    }

    const checksubscriptions =
      groupSubscription.map(plans =>
        plans.subscription_plans.filter(
          plan => plan.id === subscription.subscription_plan_id
        )
      ) || [];
    const checksubscription =
      checksubscriptions.filter(sub => sub.length > 0 && sub[0]) || [];

    return (
      <>
        <div key={subscription.id}>
          <div styleName="sub-wrraper">
            <div styleName="img-wrapper">
              <img styleName="image" src={imgUrl} alt={subscription.name} />
            </div>

            <div styleName="info">
              <h4 styleName="group-name">{`${subscription.group_name}`}</h4>
              <h5 styleName="plan-name">{`${subscription.plan_name}`}</h5>
              {subscription.subscription_type !== "campaign" && (
                <span styleName="expiry-date">
                  {" "}
                  {subscription.in_trial_period
                    ? "Billing starts on"
                    : subscription.plan_occurrence === "Recurring"
                    ? "Next due "
                    : "Valid till "}
                  {new Date(subscription.end_timestamp).toLocaleDateString(
                    "default",
                    {
                      day: "numeric",
                      month: "short",
                      year: "numeric"
                    }
                  )}
                </span>
              )}
              {subscription.subscription_type === "campaign" &&
                subscription.group_description.indexOf("legal_fund") === -1 && (
                  <p>
                    {"NL Sena"}
                    <span styleName="expiry-date">
                      {" | "}
                      {new Date(subscription.end_timestamp).toLocaleDateString(
                        "default",
                        {
                          day: "numeric",
                          month: "short",
                          year: "numeric"
                        }
                      )}
                    </span>
                  </p>
                )}

              {subscription.subscription_type === "campaign" &&
                subscription.group_description.indexOf("legal_fund") === 0 && (
                  <p>{"NL Legal Fund"}</p>
                )}
            </div>
            <div styleName="modify-wraaper">
              {(subscription.plan_occurrence === "One Time" &&
                subscription.status === "pending") ||
              subscription.subscription_type === "campaign" ||
              !showCTA
                ? null
                : checksubscription.length > 0 && (
                    <button
                      styleName="button modify"
                      onClick={() =>
                        subscription.plan_occurrence === "Recurring" &&
                        (subscription.active ||
                          subscription.status === "pending") &&
                        !isCancelled
                          ? CancelSubscriptionPlan()
                          : // : paymentCheckout(subscription)
                            navigateTo(`/subscription?ref=userdash`)
                      }
                    >
                      {isLoading &&
                      cancelSubscriptionState.id === subscription.id ? (
                        <Loader color="#ec2227" />
                      ) : subscription.expired ||
                        (isCancelled &&
                          subscription.plan_occurrence === "Recurring") ? (
                        "Renew"
                      ) : subscription.plan_occurrence === "Recurring" ? (
                        "Cancel"
                      ) : (
                        "Gift"
                      )}
                    </button>
                  )}
              {checksubscription.length >= 1 &&
              subscription.plan_occurrence === "Recurring" &&
              (subscription.active || subscription.status === "pending") &&
              !isCancelled ? (
                <button
                  styleName="button modify"
                  onClick={() =>
                    subscription.plan_occurrence === "Recurring" &&
                    (subscription.active ||
                      subscription.status === "pending") &&
                    !isCancelled
                      ? CancelSubscriptionPlan()
                      : paymentCheckout(subscription)
                  }
                >
                  Cancel
                  {/* Add the custom logn for canceling from here` */}
                </button>
              ) : null}
            </div>
          </div>
          {sucMessage && cancelSubscriptionState.id === subscription.id && (
            <p styleName="success-msg">{sucMessage}</p>
          )}
          {errorMessage && cancelSubscriptionState.id === subscription.id && (
            <p styleName="error">{errorMessage}</p>
          )}
        </div>
        {cancelProm && (
          <CancelPrompt
            member={member}
            subscription={subscription}
            user={user}
            CancelFunc={() => {
              CancelSub(subscription);
            }}
            handleClose={() => {
              setCancelProm(false);
            }}
          />
        )}
      </>
    );
  });
};

const AccountDetailsLayout = ({
  initAccessType,
  getSubscriptionForUser,
  member = {},
  config,
  navigateTo,
  cancelSubscription,
  subscriptionManage,
  isSubscriptionCanceled,
  selectedPlan,
  groupSubscription,
  campaignSubscriptions,
  hostUrl,
  paymentCheckout
}) => {
  if (!member) {
    return <LoginButton />;
  }

  const useSub = useSelector(state =>
    get(state, ["fetchSubscription", "items"], {})
  );

  const [activeButton, setActiveButton] = useState("tab1");
  const [hasSubscription, setSubscription] = useState(false);
  const [user, setUser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    country: "",
    pin_code: ""
  });
  const [activeSubscription, setActiveSubscription] = useState([]);
  const [pastSubscription, setpastSubscription] = useState([]);
  const [sucMessage, setsucMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [latestExDate, setLatestExDate] = useState("");
  const [cancelProm, setCancelProm] = useState(false);
  paymentCheckout();
  useEffect(() => {
    const subscriptonDetails = () =>
      getSubscriptionForUser()
        .then(({ subscriptions = [] }) => {
          setSubscription(true);
          setIsLoading(false);
          subscriptionManage({ status: false });
          const activeSub = subscriptions.filter(
            subscription => subscription.active === true
          );
          setActiveSubscription(activeSub);
          // const pastSub = subscriptions.filter(subscription => subscription.active !== true);
          const pastSub = subscriptions; // all purchases filter fix
          const getLatestExDate = new Date(
            Math.max.apply(
              null,
              subscriptions.map(function(e) {
                return new Date(e.end_timestamp);
              })
            )
          ).toLocaleDateString("default", {
            day: "numeric",
            month: "short",
            year: "numeric"
          });
          setLatestExDate(getLatestExDate);
          setpastSubscription(pastSub);
          return subscriptions;
        })
        .catch(error => {
          console.log("error while fetching subscription", error);
          setIsLoading(false);
          return error;
        });
    initAccessType(subscriptonDetails);
  }, []);

  useEffect(() => {
    member &&
      checkForMemberInFirebase(member)
        .then(data => {
          setUser({
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            mobile: data.phoneNumber,
            address_1: data.address_1,
            address_2: data.address_2,
            city: data.city,
            state: data.state,
            country: data.country,
            pin_code: data.pin_code
          });
        })
        .catch(error => console.log("error", error));
  }, [member]);

  function manageTab(tab) {
    setActiveButton(tab);
  }
  const setData = e => {
    const userObj = { ...user };
    const fieldName = e.target.id;
    userObj[fieldName] = e.target.value;
    setUser(userObj);
  };
  // function resetDetails() {
  //   setUser({
  //     first_name: "",
  //     last_name: "",
  //     email: user.email,
  //     mobile: "",
  //     address_1: "",
  //     address_2: "",
  //     city: "",
  //     state: "",
  //     country: "",
  //     pin_code: ""
  //   });
  // }
  function updateDetails() {
    if (!user.first_name) {
      setErrorMessage("First name required");
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
      return null;
    }
    const userObj = {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      phoneNumber: user.mobile,
      address_1: user.address_1,
      address_2: user.address_2,
      city: user.city,
      state: user.state,
      country: user.country,
      pin_code: user.pin_code,
      id: member.id
    };
    updateFirebaseUser(userObj)
      .then(() => {
        setsucMessage("Information successfully updated");
        setTimeout(() => {
          setsucMessage("");
        }, 3000);
      })
      .catch(error => {
        setErrorMessage("Oops! Something went wrong");
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
        console.log(error);
      });
  }
  return (
    <>
      <div styleName="account-wrapper">
        <div styleName="heading-wrapper">
          <h1 styleName="account-heading">Account Information</h1>
          <hr styleName="heading-border" />
        </div>
        <div styleName="tabs">
          <button
            styleName={`${
              activeButton === "tab1" ? "active-button" : ""
            } button `}
            onClick={() => manageTab("tab1")}
          >
            Active Subscription{" "}
          </button>
          <button
            styleName={`${
              activeButton === "tab2" ? "active-button" : ""
            } button `}
            onClick={() => manageTab("tab2")}
          >
            Plan History{" "}
          </button>
          <button
            styleName={`${
              activeButton === "tab" ? "active-button" : ""
            } button `}
            onClick={() => navigateTo("/saved-stories")}
          >
            Saved Stories{" "}
          </button>
          {/* <button
          styleName={`${activeButton === "tab3" ? "active-button" : ""} button `}
          onClick={() => console.log("external link here")}
        >
          Merchandise{" "}
        </button> */}
          <button
            styleName={`${
              activeButton === "tab3" ? "active-button" : ""
            } button `}
            onClick={() => {
              if (
                !isEmpty(useSub) &&
                useSub.filter(
                  sub =>
                    sub.active &&
                    (sub.group_name.toLowerCase() === "game changer" ||
                      sub.group_name.toLowerCase() === "3 year game changer")
                )[0]
              ) {
                console.log("Found");
                manageTab("tab3");
              } else {
                window.alert(
                  "Oops! This is a feature for Gamechanger subscribers only. Upgrade to Gamechanger subscription or access the podcast from our podcast player."
                );
              }
            }}
          >
            🔒 Podcast RSS 🔗{" "}
          </button>
          <button
            styleName={`${
              activeButton === "tab4" ? "active-button" : ""
            } button `}
            onClick={() => {
              if (
                // !isEmpty(useSub) &&
                // useSub.userSubscription.filter(
                //   sub =>
                //     sub.active &&
                //     (sub.group_name.toLowerCase() === "game changer" ||
                //       sub.group_name.toLowerCase() === "3 year game changer" ||
                //       sub.group_name.toLowerCase() === "disruptor")
                // )[0]
                !isEmpty(useSub) &&
                useSub.find(sub => sub.active)
              ) {
                console.log("FOUND");
                manageTab("tab4");
              } else {
                window.alert(
                  "Oops! This is a feature for Gamechanger and Disruptor subscribers only."
                );
              }
            }}
          >
            NL Discord Server{" "}
          </button>
          <button
            styleName={`${
              activeButton === "tab5" ? "active-button" : ""
            } button `}
            onClick={() => manageTab("tab5")}
          >
            Store Purchases{" "}
          </button>
        </div>
        <div className="subscription-details">
          {!isLoading ? (
            <React.Fragment>
              {hasSubscription && activeButton === "tab1" && (
                <div>
                  <h2 styleName="heading" className="desktop-only">
                    {" "}
                    Active Subscriptions{" "}
                  </h2>
                  {/* {latestExDate !== "Invalid Date" && <div>Your subscription expires on: <span styleName="text-red"> {latestExDate} </span></div>} */}
                  <GetCards
                    config={config}
                    subscriptions={activeSubscription}
                    navigateTo={navigateTo}
                    cancelSubscription={cancelSubscription}
                    cancelPrompt={[cancelProm, setCancelProm]}
                    user={user}
                    subscriptionManage={subscriptionManage}
                    isSubscriptionCanceled={isSubscriptionCanceled}
                    selectedPlan={selectedPlan}
                    groupSubscription={groupSubscription}
                    campaignSubscriptions={campaignSubscriptions}
                    showCTA={false}
                    member={member}
                  />
                </div>
              )}
              {hasSubscription && activeButton === "tab2" && (
                <GetCards
                  config={config}
                  subscriptions={pastSubscription}
                  navigateTo={navigateTo}
                  cancelSubscription={cancelSubscription}
                  subscriptionManage={subscriptionManage}
                  cancelPrompt={[cancelProm, setCancelProm]}
                  user={user}
                  isSubscriptionCanceled={isSubscriptionCanceled}
                  selectedPlan={selectedPlan}
                  groupSubscription={groupSubscription}
                  campaignSubscriptions={campaignSubscriptions}
                  hostUrl={hostUrl}
                  showCTA={false}
                  member={member}
                />
              )}
              {!hasSubscription && (
                <GetCards config={config} subscriptions={[]} />
              )}
            </React.Fragment>
          ) : (
            activeButton !== "tab5" && (
              <div styleName="sub-wrraper empty-card">
                <Loader color="#ec2227" />
              </div>
            )
          )}
        </div>
        {activeButton === "tab1" && (
          <div styleName="profile-details">
            <h2 styleName="heading">Edit Profile</h2>
            <div styleName="profile-wrapper">
              <TextField
                type="text"
                value={user.first_name}
                placeholder="First Name"
                id="first_name"
                onChange={setData}
              />
              <TextField
                type="text"
                value={user.last_name}
                placeholder="Last Name"
                id="last_name"
                onChange={setData}
              />
              <TextField
                type="email"
                value={user.email}
                placeholder="Email Address"
                id="email"
                disabled
              />
              <TextField
                type="tel"
                value={user.mobile}
                pattern="^\d{10}$"
                placeholder="Phone Number"
                id="mobile"
                onChange={setData}
              />
              {/* <h3 styleName="heading address">Address</h3>
            <TextField
              type="text"
              value={user.address_1}
              placeholder="Address Line 1"
              id="address_1"
              onChange={setData}
            />
            <TextField
              type="text"
              value={user.address_2}
              placeholder="Address Line 2"
              id="address_2"
              onChange={setData}
            />
            <TextField type="text" value={user.city} placeholder="City" id="city" onChange={setData} />
            <TextField type="text" value={user.state} placeholder="State" id="state" onChange={setData} />
            <TextField type="text" value={user.country} placeholder="Country" id="country" onChange={setData} />
            <TextField
              type="text"
              value={user.pin_code}
              pattern="[0-9]"
              maxlength="6"
              placeholder="PIN Code"
              id="pin_code"
              onChange={setData}
            /> */}
            </div>
            {sucMessage && <p styleName="success-msg">{sucMessage}</p>}
            {errorMessage && <p styleName="error">{errorMessage}</p>}
            <div styleName="actions">
              {/* <button styleName="button reset" onClick={() => resetDetails()}>
              RESET
            </button> */}
              <button
                styleName="button updated"
                onClick={() => updateDetails()}
              >
                UPDATE
              </button>
            </div>
          </div>
        )}
        {activeButton === "tab3" && <PodcastRssComponent />}
        {activeButton === "tab4" && <DiscordComponent />}
        {activeButton === "tab5" && <ShopifyPurchases />}
        {activeButton !== "tab3" && activeButton !== "tab4" && (
          <div styleName="button-wrapper">
            {/* <div styleName="first-btn">
            <a styleName="btn-style" className="nl-btn nl-btn-large" href={`${hostUrl}/subscription-explained`}>
              Subscription Explained
            </a>
          </div> */}
            <div styleName="first-btn">
              <a
                styleName="btn-style"
                className="nl-btn nl-btn-large"
                href={`${hostUrl}/faq`}
              >
                Frequently Asked Questions
              </a>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

AccountDetailsLayout.propTypes = {
  member: PropTypes.object,
  initAccessType: PropTypes.func,
  getSubscriptionForUser: PropTypes.func,
  config: PropTypes.object,
  navigateTo: PropTypes.func,
  cancelSubscription: PropTypes.func,
  subscriptionManage: PropTypes.func,
  isSubscriptionCanceled: PropTypes.bool,
  selectedPlan: PropTypes.func,
  groupSubscription: PropTypes.array,
  campaignSubscriptions: PropTypes.array
};

const AccountDetailsBase = ({
  member = {},
  config = {},
  navigateTo,
  subscriptionManage,
  isSubscriptionCanceled,
  selectedPlan,
  subscriptions,
  campaignSubscriptions,
  hostUrl,
  paymentCheckout
}) => {
  const integrationsConfig = IntegrationData();
  const email = get(member, ["email"], "");
  const phone = get(member, ["phone-number"], "");
  const isStaging = get(
    config,
    ["publisher", "publisher", "accessTypeEnvironment"],
    true
  );
  const accessTypeKey = isStaging
    ? integrationsConfig.stagingAccessTypeKey
    : integrationsConfig.accessTypeKey;
  const enableAccesstype = get(
    config,
    ["publisher", "publisher", "enableAccesstype"],
    true
  );
  const accessTypeBkIntegrationId = isStaging
    ? integrationsConfig.stagingAccessTypeBkIntegrationId
    : integrationsConfig.accessTypeBkIntegrationId;
  return (
    <AccessType
      enableAccesstype={enableAccesstype}
      isStaging={false}
      accessTypeKey={accessTypeKey}
      email={email}
      phone={phone}
      isAccessTypeCampaignEnabled={true}
      accessTypeBkIntegrationId={accessTypeBkIntegrationId}
    >
      {({ initAccessType, getSubscriptionForUser, cancelSubscription }) => {
        return (
          <AccountDetailsLayout
            initAccessType={initAccessType}
            getSubscriptionForUser={getSubscriptionForUser}
            member={member}
            config={config}
            navigateTo={navigateTo}
            cancelSubscription={cancelSubscription}
            subscriptionManage={subscriptionManage}
            isSubscriptionCanceled={isSubscriptionCanceled}
            selectedPlan={selectedPlan}
            groupSubscription={subscriptions}
            campaignSubscriptions={campaignSubscriptions}
            hostUrl={hostUrl}
            paymentCheckout={paymentCheckout}
          />
        );
      }}
    </AccessType>
  );
};

AccountDetailsBase.propTypes = {
  member: PropTypes.object,
  config: PropTypes.object,
  navigateTo: PropTypes.func,
  subscriptionManage: PropTypes.func,
  isSubscriptionCanceled: PropTypes.bool,
  selectedPlan: PropTypes.func,
  subscriptions: PropTypes.array,
  campaignSubscriptions: PropTypes.array
};

const mapStateToProps = state => {
  return {
    config: get(state, ["qt", "config"], {}),
    member: get(state, ["member"], null),
    isSubscriptionCanceled: get(
      state,
      ["isSubscriptionCancel", "status"],
      false
    ),
    subscriptions: get(state, ["subscriptions"], []),
    campaignSubscriptions: get(state, ["accessTypeCampaignSubscriptions"], []),
    hostUrl: get(state, ["qt", "currentHostUrl"], "https://www.newslaundry.com")
  };
};

const mapDispatchToProps = dispatch => ({
  navigateTo: url => global.app.navigateToPage(dispatch, url),
  subscriptionManage: function(payload) {
    dispatch({
      type: IS_SUBSCRIPTION_CANCEL,
      payload: payload
    });
  },
  selectedPlan: function(plan, redirectUrl) {
    dispatch({
      type: SELECTED_PLAN,
      plan: plan,
      planType: "standard",
      redirectUrl: redirectUrl
    });
  },
  paymentCheckout: function() {
    dispatch({
      type: PAYMENT_CHECKOUT_PAGE,
      payload: "subscription"
    });
  }
});

function PodcastRssComponent() {
  const useSub = useSelector(state =>
    get(state, ["fetchSubscription", "items"], {})
  );
  

  return (
    <div styleName="wrapper">
      <h2>Private RSS link for our podcasts that are behind the paywall</h2>
      <br />
      <p>
        As much as we prefer to have subscribers use our podcast player on the
        website, we want to make the podcast experience as frictionless as
        possible. So while we work on our iOS and Android apps, we have made
        private RSS links via which Gamechanger subscribers can access our
        paywall podcasts on their favorite podcast apps.{" "}
      </p>
      <p>Apps that will work with our private RSS link:</p>
      <div style={{ margin: "0.5rem auto" }}>
        iOS : <IosAppLogos />
      </div>
      <div style={{ margin: "0.5rem auto" }}>
        Android : <AndroidAppLogos />
      </div>

      <div styleName="card-container">
        {shows.map(show => (
          <Card key={show._id} show={show} />
        ))}
      </div>
      <div styleName="instructions">
        <h3>How do I add the RSS link to my podcast player?</h3>
        <h4>Apple Podcast</h4>
        <p>
          Click on Get Feed Link below the show icon &gt; Launch Apple Podcasts
          on your phone &gt; Tap on Library from the the menu items at the
          bottom &gt; Click on Edit at the top right &gt; Choose Add a Show by
          URL &gt; Paste the copied link and hit Subscribe
        </p>{" "}
        <h4>Google Podcast</h4>
        <p>
          Click on Get Feed Link below the show icon &gt; Launch Google Podcasts
          on your phone &gt;Tap on Activity from the menu icons at the bottom
          &gt; Choose Subscriptions from the menu at the top &gt; Click on the
          kebab icon (⋮) at the top right &gt; Click on Add by RSS feed &gt;
          Paste the copied link and hit Subscribe
        </p>{" "}
        <h4>Pocket Casts</h4>
        <p>
          Click on Get Feed Link below the show icon &gt; Launch Pocket Casts on
          your phone &gt; Tap on Discover &gt; Paste the copied link and tap on
          the search icon &gt; Select the show and hit Subscribe
        </p>{" "}
        <h4>Podcast Addict</h4>{" "}
        <p>
          Click on Get Feed Link below the show icon &gt; Launch Podcast Addict
          app on your phone &gt; Tap the “+” icon in the top right &gt; Click on
          the RSS feed icon &gt; Paste the copied link and hit Add{" "}
        </p>
        <h4>Castro</h4>{" "}
        <p>
          Click on Get Feed Link below the show icon &gt; Launch Castro on your
          phone &gt; Tap on search icon / Discover on the menu icons at the
          bottom &gt; Paste the copied link &gt; Select the show and hit
          Subscribe
        </p>
      </div>
    </div>
  );
}

function IosAppLogos() {
  const links = [
    "https://www.contiki.com/v-ch19bla5r41a/-/media/cml/resources/out-of-office-podcast/contiki-out-of-office-podcast-subscribe-apple-badge.png",
    "https://lh3.googleusercontent.com/VwSc0fESmGvRQ-6cv7-_sONmRRo1aiXJsfsf0NJzhN58i9mlOVf1W83aUjVVtiJNSZY=w268",
    "https://www.pocketcasts.com/assets/images/badges/pocketcasts_large_light.svg",
    "https://supertop.co/castro/assets/listen-in-castro.svg"
  ];
  return (
    <div
      style={{
        display: "inline-flex",
        gap: "20px",
        margin: "auto 2rem",
        flexFlow: "row wrap"
      }}
    >
      {links.map(l => (
        <img alt={l} height="48px" key={l} src={l} />
      ))}
    </div>
  );
}

function AndroidAppLogos() {
  const links = [
    "https://lh3.googleusercontent.com/VwSc0fESmGvRQ-6cv7-_sONmRRo1aiXJsfsf0NJzhN58i9mlOVf1W83aUjVVtiJNSZY=w268",
    "https://www.pocketcasts.com/assets/images/badges/pocketcasts_large_light.svg",
    "https://play-lh.googleusercontent.com/m6FeLOkUfP8qTZNXKFSSI8_exI-SlGJRcIArl3gRm3-VninL7l1RdYlPkkf2CfbBnA=s180-rw",
    "https://play-lh.googleusercontent.com/VMgWF3Uv2rTu3Z7fHFs7qhsAsfru7_q7IRN7tpT-bRyqkosxlg5RiQm7hmcfT2iAo_Y=s180-rw"
  ];
  return (
    <div
      style={{
        display: "inline-flex",
        gap: "20px",
        margin: "auto 2rem",
        flexFlow: "row wrap"
      }}
    >
      {links.map(l => (
        <img alt={l} height="48px" key={l} src={l} />
      ))}
    </div>
  );
}

function Card({ show }) {
  const useSub = useSelector(state =>
    get(state, ["fetchSubscription", "items"], {})
  );
  const [isCopied, handleCopy] = useCopyToClipboard();
  const [tokenState, setTokenState] = useState("");
  const [linkButton, setLinkButton] = useState(true);
  const [buttonText, setButtonText] = useState("Get Feed Link");
  const gameChangerSub =
    useSub &&
    useSub.find(
      sub =>
        sub.active &&
        (sub.group_name.toLowerCase() === "game changer" ||
          sub.group_name.toLowerCase() === "3 year game changer")
    );

  const showClickHandler = showId => async e => {
    try {
      if (!isEmpty(useSub)) {
        if (useSub && gameChangerSub) {
          setButtonText(Loader);
          const { token } = await getPodcastToken(
            gameChangerSub.subscriber_id,
            gameChangerSub.group_name,
            gameChangerSub.end_timestamp,
            showId
          );
          setTokenState(`https://newslaundry.com/podcast-rss/getFeed/${token}`);
          setLinkButton(false);
        } else {
          window.alert("No subscription or Not Subscribed as Game Changer");
        }
      } else {
        window.alert("login!");
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (isCopied) {
      window.alert(
        "The Rss Feed link has been Copied, paste it into your Podcast Client"
      );
    }
  }, [isCopied]);

  return (
    <div key={show._id} styleName="card">
      <img src={show.cover} height="300px" />
      {linkButton ? (
        <button onClick={showClickHandler(show._id)}>{buttonText}</button>
      ) : (
        <div styleName="contentcopy">
          <input defaultValue={tokenState} type="text" readOnly />
          <button onClick={() => handleCopy(tokenState)}>
            <MdContentCopy color="white" size="22px" />
          </button>
        </div>
      )}
    </div>
  );
}

function DiscordComponent() {
  const useSub = useUserSubscription();
  const [successMsg, setSuccessMsg] = useState({ loading: false });
  const [formData, setFormData] = useState({
    email: "",
    plan: "",
    discordId: "",
    prevId: ""
  });
  const [userDoc, setUserDoc] = useState(null);

  const submitHandler = async e => {
    e.preventDefault();
    try {
      setSuccessMsg({ ...successMsg, loading: true });
      setFormData({ ...formData, prevId: formData.discordId });
      console.log(formData);
      const res = await linkDiscordAccount(formData);
      setSuccessMsg({ ...successMsg, ...res, loading: false });
      console.log(res);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    async function fetchStuff() {
      try {
        // This is to check for Standard subscriptions while user has another active campaign subscription
        const activeNLSubs = await useSub.userSubscription.filter(
          sub =>
            sub.active &&
            ["3 year game changer", "game changer", "disruptor"].includes(
              sub.group_name.toLowerCase()
            )
        );

        const activeSenaSubs = await useSub.userSubscription.filter(
          sub =>
            sub.active &&
            !["3 year game changer", "game changer", "disruptor"].includes(
              sub.group_name.toLowerCase()
            )
        );

        let activeSub;

        if (activeNLSubs.length) {
          setFormData({
            ...formData,
            email: activeNLSubs[0].preferred_identity.value,
            plan: activeNLSubs[0].group_name
          });

          activeSub = activeNLSubs[0];
        } else if (activeSenaSubs.length) {
          setFormData({
            ...formData,
            email: activeSenaSubs[0].preferred_identity.value,
            plan: "Disruptor"
          });

          activeSub = activeSenaSubs[0];
        }

        const doc = await getDiscordIdByEmail(
          activeSub.preferred_identity.value
        );
        if (doc.email) {
          setUserDoc(doc);
        }
      } catch (e) {
        console.log(e);
      }
    }
    fetchStuff();
  }, []);

  useEffect(() => {
    if (userDoc) {
      setFormData({
        ...formData,
        discordId: userDoc.discordId,
        prevId: userDoc.discordId
      });
    }
  }, [userDoc]);

  return (
    <div styleName="wrapper" style={{ marginBottom: "3rem" }}>
      <div styleName="discord-tab-header">
        <div>
          <h2>
            Here’s how you can join our Discord server and get access to its
            subscriber-only channels
          </h2>
          <div styleName="discord-tab-steps">
            <div>
              <h3>Step 1:</h3>
              <p>
                Join our Discord Server :{" "}
                <a
                  href="https://discord.gg/EHRKe2CP6T"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#ec2227" }}
                >
                  discord.gg/EHRKe2CP6T
                </a>
              </p>
            </div>
            <div>
              <h3>Step 2:</h3>
              <p>
                Submit your Discord id in the field below. Your username
                (Johndoe#4563) is not your Discord id. It&apos;s a unique
                18-digit number.
              </p>
            </div>
          </div>
        </div>
        <img
          style={{ alignSelf: "center" }}
          src="https://images.assettype.com/newslaundry/2021-01/f79ec9db-fab6-4e2c-b305-291dd5ec4532/square_discord.jpg"
          alt="disc_square"
        />
      </div>
      <div styleName="discord-tab-main">
        <p style={{ margin: "15px auto" }}>
          To find your Discord ID go to <strong>`# find-your-id`</strong>{" "}
          channel on our server and type the command <strong>`myid`</strong>
        </p>
        {/* <img
          src="https://images.assettype.com/newslaundry/2021-01/b4a15337-647c-4b44-8087-cd57b8e7748a/discord_id_bot2.png"
          alt="disc_id"
        /> */}
        <iframe
          style={{
            display: "block",
            width: "100%",
            maxWidth: "560px",
            height: "315px"
          }}
          src="https://www.youtube-nocookie.com/embed/SKEVGRhevbs"
          frameBorder={0}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        <form
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            marginTop: "30px"
          }}
          onSubmit={submitHandler}
        >
          <TextField
            type="text"
            onChange={e =>
              setFormData({ ...formData, discordId: e.target.value })
            }
            value={formData.discordId}
            placeholder="Enter Discord ID"
            required
          />
          <Button type="submit">
            {successMsg.loading ? <Loader /> : "Submit"}
          </Button>
        </form>
        <p
          styleName="discord-tab-form-response"
          style={
            successMsg.type === "success"
              ? { color: "green" }
              : { color: "#ec2227" }
          }
        >
          {successMsg.message}
        </p>
        <div styleName="discord-tab-notes">
          {/* <img src="https://s2.gifyu.com/images/Discord_-User-id-GIF.gif" alt="Discord_-User-id-GIF.gif" border="0" /> */}
          <div>
            <h3>
              <strong>NOTE:</strong>
            </h3>
            <ul>
              <li>
                While anyone can join our Discord server, you need to link your
                Discord account here by submitting your id to get access to
                subscriber-only channels.{" "}
              </li>
              <li>
                Upon expiry of your subscription, you will lose access to the
                subscriber-only channels in this server. On renewing your
                subscription, you will automatically get access to these
                channels.
              </li>
              <li>
                We have a separate channel for overseas subscribers. If
                you&apos;re based outside India, email us your Discord username
                at{" "}
                <a
                  href="mailto:subscription@newslaundry.com"
                  style={{ color: "#ec2227" }}
                >
                  subscription@newslaundry.com
                </a>{" "}
                after you join you submit your user id here. We will add you
                there.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
}

function ShopifyPurchases() {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    getOrders();
  }, []);

  const getOrders = async () => {
    try {
      const result = await getShopifyOrders();
      setOrders(result.orders);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div styleName="wrapper" style={{ marginBottom: "3rem" }}>
      <div styleName="shopify">
        {orders !== null &&
          orders.length > 0 &&
          orders.map(i => (
            <div styleName="shopify-card" key={i.id}>
              <h3>Order {i.name}</h3>
              <ul>
                {i.line_items.map(item => (
                  <li key={item.id}>
                    {item.name} x{item.quantity} (₹{item.price})
                  </li>
                ))}
              </ul>
              <h3>Paid ₹{i.total_price}</h3>
            </div>
          ))}
        {orders !== null && orders.length < 1 && (
          <div styleName="empty-card" style={{ margin: "3rem 0" }}>
            <h2>You didn&apos;t make any purchases!</h2>
          </div>
        )}
        {orders === null && (
          <div styleName="empty-card" style={{ margin: "3rem 0" }}>
            <Loader color="#ec2227" />
          </div>
        )}
      </div>
    </div>
  );
}
export const AccountDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountDetailsBase);
